import t from "react";
import { useTranslation as d } from "react-i18next";
import s from "./restaurant.module.scss.js";
import p from "../../hooks/customization/useCustomization.js";
function g({
  id: o,
  name: l,
  phone: e,
  address: i,
  accent: m
}) {
  const { t: c } = d(), {
    getTextTranslations: u,
    configuration: a
  } = p(), n = a == null ? void 0 : a.settings.configuration.scope.find((f) => f.id === o), r = u("popup");
  return /* @__PURE__ */ t.createElement("div", { "data-testid": "restaurant", className: s.restaurantInfo }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: s.restaurantInfo__title,
      style: { color: m }
    },
    (n == null ? void 0 : n.name) ?? l
  ), /* @__PURE__ */ t.createElement("div", null, i), e && e.length > 0 && /* @__PURE__ */ t.createElement("div", null, (r == null ? void 0 : r.telephone) || c("phone"), ": ", e));
}
export {
  g as default
};
//# sourceMappingURL=Restaurant.js.map
